import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="onboardings"
export default class extends Controller {
  static targets = ["showHideAction", "showOnTrue", "showOnFalse"];

  initialize() {
    this.showHideActionTargets.forEach((el) => {
      if (el.checked == true && el.value == "false") {
        this.showOnFalseTargets.forEach((el) => (el.style.display = "block"));
      }

      if (el.checked == true && el.value == "true") {
        this.showOnTrueTargets.forEach((el) => (el.style.display = "block"));
      }
    });
  }

  showHideFields(event) {
    if (event.target.value == "false") {
      this.showOnTrueTargets.forEach((el) => (el.style.display = "none"));
      this.showOnFalseTargets.forEach((el) => (el.style.display = "block"));
    }

    if (event.target.value == "true") {
      this.showOnTrueTargets.forEach((el) => (el.style.display = "block"));
      this.showOnFalseTargets.forEach((el) => (el.style.display = "none"));
    }
  }
}
